import cadrageService from './cadrageService';
import { useCaseService } from './useCaseService';

export interface ReactFlowData {
  nodes: any[];
  edges: any[];
  // Ajoutez d'autres champs selon vos types
}

export const reactFlowService = {
  /**
   * Récupère les données ReactFlow pour un cadrage
   * @param cadrageId - L'ID du cadrage
   */
  async getCadrageFlow(cadrageId: string): Promise<ReactFlowData> {
    return cadrageService.getArchitectureFlow(cadrageId);
  },

  /**
   * Sauvegarde les données ReactFlow pour un cadrage
   * @param cadrageId - L'ID du cadrage
   * @param payload - Les données ReactFlow à sauvegarder
   */
  async saveCadrageFlow(cadrageId: string, payload: ReactFlowData): Promise<ReactFlowData> {
    return cadrageService.saveArchitectureFlow(cadrageId, payload);
  },

  /**
   * Récupère les données ReactFlow pour un cas d'usage
   * @param useCaseId - L'ID du cas d'usage
   */
  async getUseCaseFlow(useCaseId: string): Promise<ReactFlowData> {
    return useCaseService.getReactFlow(useCaseId);
  },

  /**
   * Sauvegarde les données ReactFlow pour un cas d'usage
   * @param useCaseId - L'ID du cas d'usage
   * @param payload - Les données ReactFlow à sauvegarder
   */
  async saveUseCaseFlow(useCaseId: string, payload: ReactFlowData): Promise<ReactFlowData> {
    return useCaseService.saveReactFlow(useCaseId, payload);
  }
};

export default reactFlowService;
